import { h, defineComponent, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { view_all } from '../../scene';
import { shift_pressed } from '../../keypress';
import view_all_svg from '../../../assets/img/SVG_icons/Bottom/visualisation/view_all.svg';
import { img } from '@phi/components';
import ViewAllTooltip from './ViewAllTooltip';

export const ViewAllIcon = view_all_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        disabled() {
            return this.coming_soon
                || this.state.editing_reference_sketches;
        },

        coming_soon() {
            return !this.state.loaded || this.state.tut_stage < 1;
        },

        alt() {
            return 'View entire model';
        },

        selected() {
            return this.state.tut_stage === 1;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                view_all(shift_pressed());
        },

        onLongClick() {
            if (this.disabled)
                return;
            else
                view_all(true);
        },
    },

    render() {
        return h(BarButton, {
            long: true,
            disabled: this.disabled,
            selected: this.selected,
            active: false,
            id: 'view-all-button',
            tippy: 'top',
            onClick: this.onClick,
            onLongClick: this.onLongClick,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(view_all_svg, this.alt),
            tooltip: ViewAllTooltip,
        });
    }
});
